export default __webpack_public_path__ + "static/media/IBimagekneeextensionpreswing1.a834a9dd.png";